export const USER_SIGNIN = 'USER_SIGNIN'
export const AUTH_START = 'AUTH_START'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAIL = 'AUTH_FAIL'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_CHECK_SUCCESS = 'AUTH_CHECK_SUCCESS'
export const AUTH_CHECK_FAIL = 'AUTH_CHECK_FAIL'
